export default {
  tab: {
    overview: 'Tổng quan',
    performance: 'Biến động ngành',
    proportion: 'Tỷ trọng ngành',
    fmi: 'FMI',
    investor: 'Phân loại NĐT',
  },

  indexSummary: {
    totalVolume: 'Tổng KL: ',
    totalValue: 'Tổng GT: ',
    bnVnd: 'Tỷ VND',
  },
  sectorSummary: {
    totalMatchVolume: 'Tổng KL Khớp: ',
    totalMatchValue: 'Tổng GT khớp: ',
    bnVnd: 'Tỷ VND',
  },
};
